import type { ReopenNote } from '../../data/reopenReason';
import { formatDay } from '../dates';

/**
 * "Reopened by Dee on Oct 20, 2026: “No photo — please attach one”" above a
 * completion box (owner ruling 2026-10-22). Plain text only — the reason is
 * whatever the reopener typed.
 */
export function ReopenReason({ note, className }: { note: ReopenNote; className?: string }) {
  return (
    <p className={`reopen-reason${note.undo ? ' reopen-undo' : ''}${className ? ` ${className}` : ''}`} role="note">
      {/* The store's own undo reads as that, not as a DM rejecting the work (UI review 3, S1). */}
      <strong>{note.undo ? 'Completion undone' : 'Reopened'}</strong> by {note.by}
      {formatDay(note.at) && ` on ${formatDay(note.at)}`}
      {note.reason ? <>: “{note.reason}”</> : '.'}
    </p>
  );
}
